import { render, staticRenderFns } from "./ManageInsuranceBank.vue?vue&type=template&id=a54fd40c&"
import script from "./ManageInsuranceBank.vue?vue&type=script&lang=js&"
export * from "./ManageInsuranceBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports